import { useUnexpiredDepositPendingTxs } from './useUnexpiredDepositPendingTxs'
import { useAllDepositStatus } from '../../store/deposit/hook'
import { useMemo } from 'react'
import { DepositStatus } from '../../store/deposit/types'

export function useBlockConfirmedDepositPendingTxs() {
  const unexpiredTransactions = useUnexpiredDepositPendingTxs()
  const depositStatus = useAllDepositStatus()

  return useMemo(() => {
    return unexpiredTransactions?.filter((item) => {
      return depositStatus[item.ethHash] >= DepositStatus.BlockConfirmed
    })
  }, [unexpiredTransactions, depositStatus])
}
